import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=510c53d0&scoped=true&"
import script from "./Tutorial.vue?vue&type=script&lang=js&"
export * from "./Tutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c53d0",
  null
  
)

export default component.exports